import gql from 'graphql-tag';

export default gql`
  mutation SaveAsUserMeal($input: DailyTrackerSaveAsUserMealInputType!) {
    dailyTracker {
      saveAsUserMeal(input: $input) {
        ... on DailyTrackerSaveAsUserMealSuccess {
          meal {
            id
          }
        }
        ... on ValidationException {
          code
          messages
          details {
            fieldName
            messages
          }
        }
        ... on UnauthorizedException {
          code
        }
        ... on Error {
          errorCode: code
          name
          description
        }
      }
    }
  }
`;
